export default __webpack_public_path__ + "static/media/female-icon.4df15f5b.png";